import { createTheme } from "@mui/material/styles";

/** TEBA HPU brand palette (from gym logo). */
export const HPC_COLORS = {
  navy: "#0a1628",
  navyMid: "#0d2240",
  navyCard: "rgba(18, 45, 82, 0.72)",
  tebaBlue: "#2b7cd3",
  hpuOrange: "#f5a623",
  hpuOrangeDark: "#d98912",
  silver: "#b8c5d6",
  white: "#ffffff",
  glow: "rgba(245, 166, 35, 0.35)",
};

export const hpcTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: HPC_COLORS.hpuOrange,
      contrastText: "#1a1200",
    },
    secondary: {
      main: HPC_COLORS.tebaBlue,
    },
    background: {
      default: HPC_COLORS.navy,
      paper: HPC_COLORS.navyCard,
    },
    text: {
      primary: HPC_COLORS.white,
      secondary: HPC_COLORS.silver,
    },
    success: {
      main: "#4cceac",
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h5: {
      fontWeight: 800,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
    },
    h6: {
      fontWeight: 700,
      letterSpacing: "0.04em",
      color: HPC_COLORS.hpuOrange,
    },
    subtitle2: {
      letterSpacing: "0.2em",
      textTransform: "uppercase",
      fontSize: "0.7rem",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: HPC_COLORS.navy,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 700,
          borderRadius: 10,
          minHeight: 48,
        },
        containedPrimary: {
          background: `linear-gradient(135deg, ${HPC_COLORS.hpuOrange} 0%, ${HPC_COLORS.hpuOrangeDark} 100%)`,
          boxShadow: `0 4px 20px ${HPC_COLORS.glow}`,
          "&:hover": {
            background: `linear-gradient(135deg, #ffc04d 0%, ${HPC_COLORS.hpuOrange} 100%)`,
            boxShadow: `0 6px 24px ${HPC_COLORS.glow}`,
          },
        },
        outlined: {
          borderColor: "rgba(255,255,255,0.35)",
          color: HPC_COLORS.white,
          "&:hover": {
            borderColor: HPC_COLORS.hpuOrange,
            backgroundColor: "rgba(245, 166, 35, 0.08)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
        outlined: {
          backgroundColor: "rgba(12, 28, 52, 0.6)",
          borderColor: "rgba(245, 166, 35, 0.22)",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "medium",
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            "& fieldset": {
              borderColor: "rgba(255,255,255,0.12)",
            },
            "&:hover fieldset": {
              borderColor: "rgba(43, 124, 211, 0.5)",
            },
            "&.Mui-focused fieldset": {
              borderColor: HPC_COLORS.hpuOrange,
              borderWidth: 2,
            },
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: HPC_COLORS.hpuOrange,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: HPC_COLORS.silver,
          "&.Mui-checked": {
            color: HPC_COLORS.hpuOrange,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: HPC_COLORS.silver,
          "&.Mui-checked": {
            color: HPC_COLORS.hpuOrange,
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 8,
          borderRadius: 4,
          backgroundColor: "rgba(255,255,255,0.08)",
        },
        bar: {
          borderRadius: 4,
          background: `linear-gradient(90deg, ${HPC_COLORS.tebaBlue}, ${HPC_COLORS.hpuOrange})`,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: HPC_COLORS.silver,
          fontWeight: 600,
          letterSpacing: "0.02em",
          "&.Mui-focused": {
            color: HPC_COLORS.hpuOrange,
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "rgba(245, 166, 35, 0.2)",
        },
      },
    },
  },
});
